import { connect } from 'react-redux';
import { getAnalyticsData } from '../../selectors';
import { IState } from '../../store';
import { isCountrysidePromoEnabled } from '../../utils/experiments/countrysidePromotions';
import { IPromotionsLabelStoreProps, PromotionsLabel } from './PromotionsLabel';
import { getRandomKPPromo } from '../../utils/getRandomKPPromo';

export function mapStateToProps(state: IState): IPromotionsLabelStoreProps {
  const { kp } = state.offerData;

  return {
    promotionItem: getRandomKPPromo(kp),
    analyticsData: getAnalyticsData(state),
    isEnabled: isCountrysidePromoEnabled(state),
  };
}

export const CountrysidePromoLabelContainer = connect<IPromotionsLabelStoreProps>(mapStateToProps)(PromotionsLabel);
